import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=4a63fd83&scoped=true&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"
import style0 from "./nft.vue?vue&type=style&index=0&id=4a63fd83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63fd83",
  null
  
)

export default component.exports